<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <template v-slot:activator="{ on }">
      <v-btn
        v-on="on"
        outlined
        :color="color"
        class="ml-3"
      >
        <v-icon>{{ icon }}</v-icon><span v-if="edit === false">Membro</span>
      </v-btn>
    </template>
    <v-card>
      <v-card-title
        class="modal-header elevation-10"
      >
        <v-row>
          <v-col>
            <slot name="title"></slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="dialog = false" color="white">mdi-window-close</v-icon>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <app-member-combobox
              :filter="payload"
              :disabled="payload.disabledMember"
              @onChange="changeMember()"
            ></app-member-combobox>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <app-group-combobox
              :filter="payload"
              :disabled="payload.disabled"
            ></app-group-combobox>
          </v-col>
        </v-row>

        <v-row>
          <v-col sm="6">
            <v-text-field
              label="CPF"
              name="cpf"
              type="text"
              masked
              required
              v-mask="'###.###.###-##'"
              v-model="payload.membro.cpf"
              @blur="loadMember()"
            ></v-text-field>
          </v-col>

          <v-col sm="6">
            <v-text-field
              label="Nome Completo"
              name="nome"
              type="text"
              required
              v-model="payload.membro.nome"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col sm="6">
            <v-text-field
              label="Email"
              name="email"
              type="text"
              required
              v-model="payload.membro.email"
            ></v-text-field>
          </v-col>

          <v-col sm="6">
            <v-text-field
              label="Melhor telefone"
              name="telefone"
              type="text"
              required
              v-model="payload.membro.telefone"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col sm="6">
            <v-text-field
              label="Órgão / Secretaria"
              name="orgao"
              type="text"
              required
              v-model="payload.membro.orgao"
            ></v-text-field>
          </v-col>

          <v-col sm="6">
            <v-text-field
              label="Cargo / Função"
              name="funcao"
              type="text"
              required
              v-model="payload.membro.cargo"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col
          >
            <v-checkbox
              v-model="payload.membro.membroGrupos[0].lider"
              label="Lider ?"
              color="primary"
            >
            </v-checkbox>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="dialog = false">Fechar</v-btn>
        <v-btn color="info" outlined text @click="onConfirm">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { memberAPI } from '../MemberAPI'
import { AppGroupCombobox, AppMemberCombobox } from '@/modules/city'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'AppModalInsertMember',
  props: {
    object: { type: Object, required: false },
    edit: { type: Boolean, required: false, default: false },
    icon: { type: String, required: true },
    color: { type: String, required: true },
    municipioId: { required: true },
    grupoId: { required: false }
  },
  components: {
    AppGroupCombobox,
    AppMemberCombobox
  },
  data () {
    return {
      payload: {
        membro: {
          membroGrupos: [{}]
        },
        municipioId: this.municipioId
      },
      dialog: false,
      filter: {
        municipioId: this.municipioId
      }
    }
  },
  computed: {
    ...mapGetters([
      'loading',
      'isAdmin',
      'isConsultorCondutorMunicipio',
      'isConsultorEspecialistaMunicipio',
      'isADMunicipio',
      'isAuthenticated',
      'isSPFesp',
      'isSPFespEspecial',
      'isSPCoordenador',
      'uf'
    ])
  },
  methods: {
    ...mapActions([
      'setLoading'
    ]),
    onConfirm () {
      if (!this.payload.membro.nome) {
        this.$notification.error('O nome é obrigatório')
      } else if ((!this.payload.membro.cpf || !this.isValidCPF(this.payload.membro.cpf)) && this.uf !== 'MA') {
        this.$notification.error('O CPF é obrigatório e deve ser válido')
      } else if (!this.payload.membro.email) {
        this.$notification.error('O e-mail é obrigatório')
      } else {
        this.setLoading(true)
        this.payload.membro.membroGrupos[0].grupoId = this.payload.grupoId
        if (!this.payload.membro.membroId) {
          memberAPI.create(this.payload.membro)
            .then(resp => {
              this.dialog = false
              this.payload.grupoId = this.grupoId
              this.payload.membro.grupoId = this.grupoId
              this.payload.membro.cpf = null
              this.payload.membro.nome = null
              this.payload.membro.email = null
              this.payload.membro.telefone = null
              this.payload.membro.orgao = null
              this.payload.membro.cargo = null
              this.payload.membro.membroGrupos = [{}]
              this.payload.municipioId = this.municipioId
              this.$emit('onSave')
            })
            .catch(this.setLoading(false))
        } else {
          this.payload.membro.membroGrupos[0].membroId = this.payload.membro.membroId
          memberAPI.update(this.payload.membro)
            .then(resp => {
              this.dialog = false
              this.payload.membro.membroId = null
              this.payload.grupoId = this.grupoId
              this.payload.membro.grupoId = this.grupoId
              this.payload.membro.cpf = null
              this.payload.membro.nome = null
              this.payload.membro.email = null
              this.payload.membro.telefone = null
              this.payload.membro.orgao = null
              this.payload.membro.cargo = null
              this.payload.membro.membroGrupos = [{}]
              this.payload.municipioId = this.municipioId
              this.$emit('onSave')
            })
            .catch(this.setLoading(false))
        }
      }
    },
    loadMember () {
      this.setLoading(true)
      memberAPI.get(this.payload.membro.cpf)
        .then(resp => {
          if (resp.data !== '') {
            this.payload.membro = resp.data
            this.payload.membro.membroGrupos = [{}]
          }
          this.setLoading(false)
        })
        .catch(this.setLoading(false))
    },
    isValidCPF (cpf) {
      if (typeof cpf !== 'string') {
        return false
      }

      let cleancpf = cpf.replace(/[\s.-]*/igm, '')
      if (
        !cleancpf ||
        cleancpf.length !== 11 ||
        cleancpf === '00000000000' ||
        cleancpf === '11111111111' ||
        cleancpf === '22222222222' ||
        cleancpf === '33333333333' ||
        cleancpf === '44444444444' ||
        cleancpf === '55555555555' ||
        cleancpf === '66666666666' ||
        cleancpf === '77777777777' ||
        cleancpf === '88888888888' ||
        cleancpf === '99999999999'
      ) {
        return false
      }
      var soma = 0
      var resto
      for (var i = 1; i <= 9; i++) {
        soma = soma + parseInt(cleancpf.substring(i - 1, i)) * (11 - i)
      }
      resto = (soma * 10) % 11
      if ((resto === 10) || (resto === 11)) resto = 0
      if (resto !== parseInt(cleancpf.substring(9, 10))) return false
      soma = 0
      for (var j = 1; j <= 10; j++) {
        soma = soma + parseInt(cleancpf.substring(j - 1, j)) * (12 - j)
      }
      resto = (soma * 10) % 11
      if ((resto === 10) || (resto === 11)) resto = 0
      if (resto !== parseInt(cleancpf.substring(10, 11))) return false
      return true
    },
    changeMember () {
      this.payload.membro.membroId = this.payload.membroLocal.membroId
      this.payload.membro.grupoId = this.grupoId
      this.payload.membro.cpf = this.payload.membroLocal.cpf
      this.payload.membro.nome = this.payload.membroLocal.nome
      this.payload.membro.email = this.payload.membroLocal.email
      this.payload.membro.telefone = this.payload.membroLocal.telefone
      this.payload.membro.orgao = this.payload.membroLocal.orgao
      this.payload.membro.cargo = this.payload.membroLocal.cargo
      this.$forceUpdate()
    }
  },
  mounted () {
    if (this.object && this.edit === true) {
      this.payload.membro = this.object
      this.payload.grupoId = this.object.membroGrupos[0].grupoId
      this.payload.disabledMember = true
    } else if (this.grupoId) {
      this.payload.grupoId = parseInt(this.grupoId)
      this.payload.disabled = true
    }
  }
}
</script>
